<div class="vault-module-shell">
  @if (accessDenied() && !isSuperadminSession()) {
    <app-vault-access-denied [moduleLabel]="moduleLabel()" />
  } @else if (loadError()) {
    <lib-alert
      type="error"
      [title]="loadErrorTitle()"
      [message]="loadError()!"
      [closeButton]="true"
    />
  } @else {
    <ng-content />
  }
</div>
